import { createContext, useState, useContext, useEffect } from 'react'

const ScrollTriggerContext = createContext();
const ScrollTriggerProvider = ({ children }) => {
  const [scrollTrigger, setScrollTrigger] = useState(false)

  const useScrollTriggerEffect = (trigger) => {
    useEffect(() => {
      setScrollTrigger(trigger)
    }, [trigger])
  }

  return (
    <ScrollTriggerContext.Provider value={{ scrollTrigger, setScrollTrigger, useScrollTriggerEffect }}>
      {children}
    </ScrollTriggerContext.Provider>
  )
}

const useScrollTriggerContext = () => useContext(ScrollTriggerContext)

export default useScrollTriggerContext

export { ScrollTriggerContext, ScrollTriggerProvider, useScrollTriggerContext }
